import React from 'react';
const Footer = () => {
    return <section>
      <div className='flex justify-center text-accent'>
        <p>&copy;2023 <span>| Developed by Mridul</span></p>
      </div>
    </section>;
  };
  
  export default Footer;
  
